export default "__VITE_PUBLIC_ASSET__233f35e5__"